import { Fade, IconButton, Tooltip } from '@mui/material';
import { Check, ContentCopy } from '@mui/icons-material';
import React, { useState } from 'react';
import { CopyIconButtonProps } from 'src/components/CopyButton/CopyButton.types';
import { useTranslation } from 'react-i18next';

export const CopyIconButton: React.FC<CopyIconButtonProps> = ({ textToCopy }) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <Tooltip
      title={t(copied ? 'configScreen.actions.copied' : 'configScreen.actions.copy') ?? ''}
      placement="bottom"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 200 }}>
      <IconButton
        onClick={handleCopy}
        size="small"
        sx={{
          color: 'white',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'scale(1.1)',
          },
        }}>
        {copied ? (
          <Check
            fontSize="small"
            sx={{
              color: '#4caf50',
              transition: 'color 1s ease-in-out',
            }}
          />
        ) : (
          <ContentCopy fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};
